import { Currency } from 'chaika-enums';
import { CurrencyIcon } from '../types';

export const FACTOR = 100;

export interface MoneyFormat {
    withCurrencySign?: boolean;
    delimiter?: string;
    withoutKopecks?: boolean;
    hiddenCurrency?: boolean;
}

export class Money {
    public static fromRubles(amount: number, currency?: Currency): Money {
        return new Money(amount * FACTOR, currency);
    }

    public static kopecksFromRubles(amount: number): number {
        return new Money(amount * FACTOR).kopecks;
    }

    public static fromKopecks(amount: number, currency?: Currency): Money {
        return new Money(amount, currency);
    }

    public static fromKopecksToRublesString(amount: number, currency?: Currency): string {
        return new Money(amount, currency).toString({ withoutKopecks: true });
    }

    public static fromRublesToRublesString(amount: number, currency?: Currency): string {
        return new Money(amount * FACTOR, currency).toString({ withoutKopecks: true });
    }

    public currency: Currency;
    private amount: number;

    constructor(amount = 0, currency: Currency = Currency.RUB) {
        this.amount = amount;
        this.currency = currency;
    }

    public get rubles(): number {
        return this.amount / FACTOR;
    }

    public get kopecks(): number {
        return this.amount;
    }

    public toString(format: MoneyFormat = {}): string {
        const { withCurrencySign = true, delimiter = '.', withoutKopecks = false } = format;

        const price = this.rubles
            .toFixed(withoutKopecks ? 0 : 2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
            .replace('.', delimiter);

        if (withCurrencySign) {
            return `${price} ${!format.hiddenCurrency ? CurrencyIcon[this.currency] : ''}`;
        }

        return price;
    }
}
